import { useReportsContext } from '@/dashboards/Reports/hooks';
import { Button, Modal } from '@analytical-alley/ui';
import { useCallback } from 'react';
import { DocumentViewer } from 'react-documents';

export const ReportPreviewModal = () => {
    const { previewReportUrl, flushPreviewReportUrl } = useReportsContext();
    const showModal = !!previewReportUrl;
    const onClose = useCallback(
        () => flushPreviewReportUrl(),
        [flushPreviewReportUrl],
    );

    return (
        <Modal
            show={showModal}
            onClose={onClose}
            size="full"
            className="w-full"
        >
            <Modal.Header>Report preview</Modal.Header>

            <Modal.Body className="h-full">
                <div
                    className="flex flex-col gap-2 w-full h-full"
                    style={{ minHeight: '70dvh' }}
                >
                    {showModal && (
                        <DocumentViewer
                            url={previewReportUrl}
                            viewer="google"
                            className="w-full h-full"
                            style={{ minHeight: '60dvh' }}
                        />
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="py-4">
                <Button
                    className="ml-2"
                    size="sm"
                    color="red"
                    onClick={onClose}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
